import { z } from 'zod';
import { reportCubeQuerySchema, reportDisplayConfigSchema, reportPdfConfigSchema, } from './query-schema.js';
export const reportOutputTypeSchema = z.enum([
    'table',
    'bar',
    'line',
    'pie',
    'donut',
    'horizontal_bar',
]);
export const CHART_OUTPUT_TYPES = [
    'bar',
    'donut',
    'horizontal_bar',
    'line',
    'pie',
];
export const reportCategoryCreateSchema = z.object({
    name: z
        .string('Name is required')
        .min(1, 'Name is required')
        .max(255, 'Name must be less than 255 characters'),
    description: z
        .string()
        .max(1000, 'Description must be less than 1000 characters')
        .nullable()
        .optional(),
    color: z.string().max(50, 'Color must be less than 50 characters').nullable().optional(),
});
export const reportCategoryUpdateSchema = reportCategoryCreateSchema.partial();
export const reportCreateSchema = z.object({
    name: z
        .string('Name is required')
        .min(1, 'Name is required')
        .max(255, 'Name must be less than 255 characters'),
    description: z
        .string()
        .max(1000, 'Description must be less than 1000 characters')
        .nullable()
        .optional(),
    outputType: reportOutputTypeSchema.default('table'),
    categoryId: z.number().int().nullable().optional(),
    displayConfig: reportDisplayConfigSchema.optional(),
    pdfConfig: reportPdfConfigSchema.optional(),
    query: reportCubeQuerySchema,
});
export const reportUpdateSchema = reportCreateSchema.partial();
